type Leaves<T, L0 = T[keyof T]> = L0 extends Record<string, unknown> ? Leaves<L0> : L0
export type EinwertColor = Leaves<typeof palette>

const palette = {
    primary: {
        main: '#0A1866',
    },
    secondary: {
        main: '#17AD86',
        contrast: '#139369',
        contrastText: '#FFFFFF',
    },
    success: {
        main: '#17AD86',
        contrastText: '#FFFFFF',
    },
    primary1: {
        blue100: '#0A1866',
        blue50: '#848BB2',
        blue20: '#CED0E0',
    },
    primary2: {
        green100: '#17AD86',
        green50: '#8AD5C2',
        green20: '#D0EFE7',
        green10: '#17ad861a',
    },
    secondary1: {
        grey: '#F2F2F2',
        lightblue: '#F7F8FF',
        contrast: '#D9D9D9',
    },
    customtext: {
        darkblue100: '#08124A',
        darkblue50: '#8388A4',
        black10: '#F2F2F2',
        black20: '#E6E6E6',
        black23: '#C4C4C4',
        black38: '#9E9E9E',
        black54: '#757575',
        black60: '#676767',
        black80: '#333333',
        black100: '#000000',
        lightgrey: '#808080',
    },
    white: '#FFFFFF',
    green: {
        green10: '#F3FBF9',
        green50: '#8AD5C2',
        green110: '#16A47F',
    },
    marker: {
        green: '#008000',
        red: '#FF0000',
    },
    danger: {
        main: '#D32F2F',
        contrast: '#AA2424',
    },
    chartColors: {
        green: '#17AD86',
        blue: '#0A1866',
        turqouise: '#66C8CE',
        skyblue: '#0D95BC',
        yellow: '#D7E257',
        orange: '#E9854E',
        lightOrange: '#E9B44E',
        grassGreen: '#61BD7B',
        cobalt: '#2C4E8F',
        azure: '#0075B3',
    },
    chartColorsShaded: {
        green: '#149472',
        blue: '#08124D',
        turqouise: '#51B0B5',
        skyblue: '#0B81A3',
        yellow: '#C0C94D',
        orange: '#CF7645',
        lightOrange: '#CFA045',
        grassGreen: '#54A36A',
        cobalt: '#244075',
        azure: '#006499',
    },
    status: {
        green: '#17AD86',
        green120: '#128567',
        yellow: '#FBC400',
        blue: '#0BA8EC',
        mutedBlue: '#7D8AD2',
        red: '#E56B63',
        red110: '#CE6059',
        red120: '#B7564F',
        lightred: '#FFF1F0',
    },
    taskStatus: {
        draft: '#9E9E9E',
        open: '#74A8E4',
        inProgress: '#ECB86A',
        inReview: '#848BB2',
        done: '#17AD86',
    },
    error: {
        main: '#E56B63',
    },
    warning: {
        main: '#ECB86A',
    },
    info: {
        main: '#74A8E4',
    },
} as const

export default palette
